import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

class Show extends React.Component {
  static propTypes = {
    eventlog: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    const { eventlog } = this.props;
    if (!eventlog) return null;
    return (
      <div className="container-fluid">
        <h3 className="mt-3">イベントログ詳細</h3>
        <div className="card mt-4">
          <div className="card-body">
            <dl className="row mb-0">
              <dt className="col-sm-3">ユーザーID</dt>
              <dd className="col-sm-9">{eventlog.user_id}</dd>
              <dt className="col-sm-3">ULID</dt>
              <dd className="col-sm-9">{eventlog.ulid || '-'}</dd>
              <dt className="col-sm-3">発生日時</dt>
              <dd className="col-sm-9">
                {formatTimestamp(eventlog.created_at)}
              </dd>
              <dt className="col-sm-3">イベント種別</dt>
              <dd className="col-sm-9">{eventlog.event_type || '-'}</dd>
              <dt className="col-sm-3">ステータス</dt>
              <dd className="col-sm-9">{eventlog.status || '-'}</dd>
              <dt className="col-sm-3">メッセージ</dt>
              <dd className="col-sm-9">
                {eventlog.message || <span className="text-muted">-</span>}
              </dd>
            </dl>
            <div className="mt-4">
              <h5>ペイロード</h5>
              <pre className="bg-light p-3 rounded">
                {JSON.stringify(eventlog, null, 2)}
              </pre>
            </div>
            <div className="mt-4">
              <a
                href="#!"
                className="btn btn-secondary"
                onClick={this.handleBack}
              >
                一覧に戻る
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleBack = (e) => {
    e.preventDefault();
    if (this.props.actions.clearDetail) {
      this.props.actions.clearDetail();
    } else {
      this.props.actions.receiveEventlog(null);
    }
  };
}

const formatTimestamp = (value) => {
  if (value === null || typeof value === 'undefined') return '-';
  const numeric = Number(value);
  if (!isNaN(numeric)) {
    if (numeric > 9999999999) {
      return moment(numeric).format('YYYY/MM/DD HH:mm:ss');
    }
    return moment.unix(numeric).format('YYYY/MM/DD HH:mm:ss');
  }
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format('YYYY/MM/DD HH:mm:ss') : value;
};

export default Show;
